import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, RouteComponentProps } from 'react-router-dom'
import { TwButton } from '../../components/Button/TwButton'
import { DELETE_ACCOUNT_PATH } from '../../utils/publicPaths'
import { DeleteAccountLayout } from './DeleteAccountLayout.component'
import { useDeleteAccountConfirm } from './useDeleteAccountConfirm.hook'

export const DeleteAccountConfirm: React.FC<RouteComponentProps> = ({ location }) => {
  const { t } = useTranslation()
  const { status, error, confirm } = useDeleteAccountConfirm(location.search)

  const requestNewLink = (
    <Link
      to={DELETE_ACCOUNT_PATH}
      className="mt-4 text-sm font-medium text-center text-brand hover:underline"
    >
      {t('deleteAccount.requestNewLink')}
    </Link>
  )

  const body = (() => {
    switch (status) {
      case 'confirmed':
        return <p className="text-sm text-gray-600 text-center">{t('deleteAccount.confirmed')}</p>
      case 'invalidLink':
      case 'expired':
        return (
          <>
            <p className="text-sm text-gray-600 text-center">{t(`deleteAccount.${status}`)}</p>
            {requestNewLink}
          </>
        )
      default:
        return (
          <>
            <p className="text-sm text-gray-600 text-center">
              {t('deleteAccount.confirmDescription')}
            </p>
            {error && (
              <p className="mt-4 text-sm text-red-500 text-center">
                {t(`deleteAccount.error.${error}`)}
              </p>
            )}
            <TwButton
              color="danger"
              size="md"
              onClick={confirm}
              disabled={status === 'loading'}
              className="mt-6 w-full"
            >
              {t('deleteAccount.confirm')}
            </TwButton>
          </>
        )
    }
  })()

  return <DeleteAccountLayout title={t('deleteAccount.confirmTitle')}>{body}</DeleteAccountLayout>
}
